import { BaseForPlanHelper } from 'wizards/models/base/base-models/base-for-plan-helper';

export class BaseForVMPlanHelper extends BaseForPlanHelper {
  static clearAppAwareData(newPlan: any): void {
    delete newPlan.AppAwareGuestVmIndividualSettings;
  }
}
